import CircleLoader from '@components/CircleLoader'
import { withTranslate } from 'i18n/utils'

const DeleteButton = ({ onClick, pending, translate: t }) =>
    pending ? (
        <CircleLoader className="ml-2" size="small" />
    ) : (
        <button aria-label={t('dashboard.label.deleteButton')} className="delete toggleVisible" onClick={onClick} />
    )

export default withTranslate(DeleteButton)
